'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _ArrowDownOutlined = _interopRequireDefault(require('./lib/icons/ArrowDownOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _ArrowDownOutlined;
  exports.default = _default;
  module.exports = _default;